/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    import IReportsControllerScope = DealerwareWebComponents.IReportsControllerScope;

    export class CollectionListPagerDirectiveController {

        public static $inject : string[] = [
            '$q', '$timeout', '$scope', '$rootScope', '$dealerwareNotification', 'DataUtils', '$dealerwareInternationalizationData'
        ];


        public collectionName           : string;
        public error                    : string;
        public collection               : any;
        public onPageTransitionStart    : any;
        public onPageTransitionSuccess  : any;
        public onPageTransitionError    : any;
        public showLoadAll              : boolean;
        public hideSinglePagePager      : boolean;
        public showExportCsv            : boolean;
        public exportFilePrefix         : string;
        public exportColumns            : any;

        public showPerPage              : boolean;
        public showGoToPage             : boolean;
        public paginationEventHandler   : any;

        public downloadCsvStatus        : any = '';
        public downloadCsvData          : any = { };
        public downloadCsvDataToast     : any;
        public labels            : {};

        // Avoids backend work.
        //
        public allResultsPlaceholder: number = 999999;

        public perPageOptions: Object[] = [
            { value: 30, display: '30' },
            { value: 100, display: '100' }
        ];
        public pageSizes: any;

        public currentPageNumber: number = 1;

        public utils: any;

        constructor(
            public $q           : any,
            public $timeout     : any,
            public $scope       : IReportsControllerScope,
            public $rootScope   : ng.IScope,
            public $dealerwareNotification : any,
            public DataUtils : any,
            public $dealerwareInternationalizationData: any
        ) {
            var _self = this;

            this.getLabels('reports');

            this.utils = this.DataUtils.getInstance();

            this.clearError();

            if (this.showPerPage) {

                // Watch out for changes to the (number of results) perPage select.
                //
                this.$scope.$watch(
                    ( ) => {
                        return _self.collection
                            && _self.collection.pagination
                            && _self.collection.pagination.perPage;
                    },
                    ( paginationNew: any, paginationOld: any ) => {

                        // Make sure perPage has actually been changed before firing,
                        // to avoid multiple useless requests.
                        //
                        if ( paginationNew !== undefined
                            && paginationOld !== undefined
                            && parseInt(paginationNew, 10) !== parseInt(paginationOld, 10)
                        ) {
                            _self.currentPageNumber = 1;
                            _self.collection.pagination.currentPage = 1;
                            _self.loadSpecificPage();
                        }
                    });
            }

            if (this.showGoToPage) {

                // Watch out for changes to the Page Number select.
                //
                this.$scope.$watch(
                    ( ) => {
                        return _self.collection
                            && _self.collection.pagination
                            && _self.collection.pagination.currentPage;
                    },
                    ( currentPageNumberNew: any, currentPageNumberOld: any ) => {

                        // Make sure perPage has actually been changed before firing,
                        // to avoid multiple useless requests.
                        //
                        if ( currentPageNumberNew !== undefined
                            && currentPageNumberOld !== undefined
                            && parseInt(currentPageNumberNew, 10) !== parseInt(currentPageNumberOld, 10)
                        ) {
                            _self.loadSpecificPage();
                        }
                    });
            }

            // Listen for pagination events (CSV exports) for this named collection, so that
            // CSV exports can be triggered from elements and code external to the collection.
            //
            if (_self.collectionName) {

                // Pagination events for multiple pagers on the same page are isolated from each other
                // if the collectionNames are different.
                //
                var paginationEventHandler = $rootScope.$on('paginationEvent' + _self.collectionName,
                    ( e: ng.IAngularEvent, args: any ) => {

                    if (args.action === 'exportAsCSV') {
                        _self.exportAsCSV();
                    }
                    else if (args.action === 'exportAllAsCSV') {
                        _self.exportAllAsCSV();
                    }
                });

                this.$scope.$on('$destroy', function () {
                    paginationEventHandler();
                });
            }
            // Set passed-in page sizes, if given.
            //
            if (this.pageSizes) {
                this.perPageOptions = this.pageSizes;
            }

            this.$scope.showTimeRemaining = true;
            this.downloadCsvData = {

                processedRecords: ( ) => {
                    return this.downloadCsvData.stats.processed.itemCount;
                },

                stats  : {
                    total: {
                        label: 'Total',
                        itemCount: 0
                    },
                    processed: {
                        itemCount: 0
                    }
                }
            };
        }

        public getLabels(module: string) : void {
            const _self = this;
            this.$dealerwareInternationalizationData
                .getLabels()
                .then( function(res) {
                    _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                    _self.perPageOptions.push(
                        { value: _self.allResultsPlaceholder, display: _self.labels.pager.all }
                    )
                },
                function(error: any) {
                    _self.$dealerwareNotification.apiError(error);
                }
            );
        }

        public pageIndexes() : number[] {

            var pages : number[] = [ ];

            if (this.collection && this.collection.pagination && this.collection.pagination.totalPages) {
                for (var i = 1; i <= this.collection.pagination.totalPages; i++) {
                    pages.push(i);
                }
            }

            return pages;
        }

        public showingAllResults() : boolean {
            return this.collection
                && this.collection.pagination
                && this.collection.pagination.perPage === this.allResultsPlaceholder
        }

        public hasError() : boolean {
            return (this.error) ? true : false;
        }

        public clearError() : void {
            this.error = undefined;
        }

        public setError(error : string) : void {
            this.error = error;
        }

        public loadNextPage() : void {
            var _self = this;

            if (_self.onPageTransitionStart && angular.isFunction(_self.onPageTransitionStart)) {
                _self.onPageTransitionStart();
            }

            this.collection.$nextPage({
                successCallback: function() {
                    if (_self.onPageTransitionSuccess && angular.isFunction(_self.onPageTransitionSuccess)) {
                        _self.onPageTransitionSuccess();
                    }
                },
                errorCallback: function(response : any) {
                    if (_self.onPageTransitionError && angular.isFunction(_self.onPageTransitionError)) {
                        _self.onPageTransitionError({response: response});
                    }
                },
                per_page: this.collection.pagination.perPage
            });
        }

        public loadPreviousPage() : void {
            var _self = this;

            if (_self.onPageTransitionStart && angular.isFunction(_self.onPageTransitionStart)) {
                _self.onPageTransitionStart();
            }

            this.collection.$previousPage({
                successCallback: function() {
                    if (_self.onPageTransitionSuccess && angular.isFunction(_self.onPageTransitionSuccess)) {
                        _self.onPageTransitionSuccess();
                    }
                },
                errorCallback: function(response: any) {
                    if (_self.onPageTransitionError && angular.isFunction(_self.onPageTransitionError)) {
                        _self.onPageTransitionError({ response: response });
                    }
                },
                per_page: this.collection.pagination.perPage
            });
        }

        public loadSpecificPage() : void {
            var _self = this;

            if (_self.onPageTransitionStart && angular.isFunction(_self.onPageTransitionStart)) {
                _self.onPageTransitionStart();
            }

            this.collection.$goToPage(this.collection.pagination.currentPage, {
                successCallback: function() {
                    if (_self.onPageTransitionSuccess && angular.isFunction(_self.onPageTransitionSuccess)) {
                        _self.onPageTransitionSuccess();
                    }

                },
                errorCallback: function(response: any) {
                    if (_self.onPageTransitionError && angular.isFunction(_self.onPageTransitionError)) {
                        _self.onPageTransitionError({ response: response });
                    }
                },
                per_page: this.collection.pagination.perPage
            });
        }

        public loadAll() : void {
            var _self = this;

            if (_self.onPageTransitionStart && angular.isFunction(_self.onPageTransitionStart)) {
                _self.onPageTransitionStart();
            }

            if (this.collection.pagination.currentPage > 1) {
                this.collection.$goToPage(1, {
                    successCallback: function() {
                        _self.collection.$loadAll({
                            finalSuccessCallback: function() {
                                if (_self.onPageTransitionSuccess && angular.isFunction(_self.onPageTransitionSuccess)) {
                                    _self.onPageTransitionSuccess();
                                }
                            },
                            errorCallback: function(response: any) {
                                if (_self.onPageTransitionError && angular.isFunction(_self.onPageTransitionError)) {
                                    _self.onPageTransitionError({ response: response });
                                }
                            }
                        });
                    },
                    errorCallback: function(response: any) {
                        if (_self.onPageTransitionError && angular.isFunction(_self.onPageTransitionError)) {
                            _self.onPageTransitionError({ response: response });
                        }
                    }
                });
            } else {
                this.collection.$loadAll({
                    finalSuccessCallback: function() {
                        if (_self.onPageTransitionSuccess && angular.isFunction(_self.onPageTransitionSuccess)) {
                            _self.onPageTransitionSuccess();
                        }
                    },
                    errorCallback: function(response: any) {
                        if (_self.onPageTransitionError && angular.isFunction(_self.onPageTransitionError)) {
                            _self.onPageTransitionError({ response: response });
                        }
                    }
                });
            }
        }

        public getVisibleExportColumns() : {} {
            if (!this.exportColumns) { throw 'no columns defined'; }

            return ($.grep(this.exportColumns, (c: any) => {
                if ('hidden' in c) {
                    return typeof(c.hidden) === 'function' ? !c.hidden() : !c.hidden;
                }

                return c;
            }));
        }

        public downloadCsvStatusText() : string {
            return this.downloadCsvStatus;
        }

        public exportAllAsCSV() : void {
            var _self = this;

            if (_self.onPageTransitionStart && angular.isFunction(_self.onPageTransitionStart)) {
                _self.onPageTransitionStart();
            }

            // Setup toast.
            //
            this.downloadCsvDataToast = this.$dealerwareNotification;
            this.downloadCsvDataToast.fullToast ({
                templateUrl     : '/components/progress-toast/progress-toast-directive.html',
                hideDelay       : 0,
                scope           : angular.extend(this.$scope, {
                    progressData        : this.downloadCsvData,
                    statusText          : ( ) => this.downloadCsvStatusText.call(this),
                    showTotalItemCount  : true
                }),
                preserveScope   : true
            });

            var dismissToast = function() {
                if (_self.downloadCsvDataToast) {
                    _self.$timeout( function() {
                        _self.downloadCsvDataToast.$mdToast.cancel();
                        _self.downloadCsvDataToast = null;
                    }, 6000);
                }
            };

            this.downloadCsvStatus = 'Downloading...';
            this.$scope.timeRemaining = '';
            this.$scope.showTimeRemaining = true;

            var estimator = new this.utils.remainingTimeEstimator();
            estimator.start(null, 5);

            var firstSuccess = false;

            this.collection.$exportAllCSV({
                exportFilePrefix: this.exportFilePrefix,
                columnDefs: this.getVisibleExportColumns(),
                successCallback: function(stats: any) {
                    _self.downloadCsvData.stats.total.itemCount = stats.total.itemCount;
                    _self.downloadCsvData.stats.processed.itemCount = stats.processed.itemCount;

                    if (firstSuccess) {
                        _self.$scope.timeRemaining = estimator.mark(
                            _self.downloadCsvData.stats.processed.itemCount,
                            _self.downloadCsvData.stats.total.itemCount
                        );
                    }
                    else {
                        firstSuccess = true;
                    }
                },
                finalSuccessCallback: function(stats: any) {
                    _self.downloadCsvData.stats.processed.itemCount = stats.processed.itemCount;

                    dismissToast();
                    estimator.finish();
                    _self.$scope.showTimeRemaining = false;
                    _self.downloadCsvStatus = 'Download Complete';

                    if (_self.onPageTransitionSuccess && angular.isFunction(_self.onPageTransitionSuccess)) {
                        _self.onPageTransitionSuccess();
                    }
                },
                errorCallback: function(response: any) {
                    if (_self.onPageTransitionError && angular.isFunction(_self.onPageTransitionError)) {
                        _self.onPageTransitionError({ response: response });
                    }

                    dismissToast();
                    _self.downloadCsvStatus = 'Download Error';

                }
            });
        }

        public exportAsCSV(): void {
            this.collection.$exportCSV({
                exportFilePrefix: this.exportFilePrefix,
                columnDefs: this.getVisibleExportColumns()
            });
        }
    }

    getDealerwareWebComponentsModule().controller('CollectionListPagerDirectiveController', CollectionListPagerDirectiveController);


    export class CollectionListPagerDirective implements ng.IDirective {

        public restrict         : string    =   'E';
        public controller       : any       =   'CollectionListPagerDirectiveController';
        public controllerAs     : string    =   'pagerController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {
            collection              : '=',
            collectionName          : '=',
            onPageTransitionStart   : '&',
            onPageTransitionSuccess : '&',
            onPageTransitionError   : '&',
            hideSinglePagePager     : '=',
            showLoadAll             : '=',
            showExportCsv           : '=',
            exportFilePrefix        : '=',
            exportColumns           : '=',
            showGoToPage            : '=?',
            showPerPage             : '=?',
            pageSizes               : '=?'
        };
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/collection_list/collection_list_pager_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {}
    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareCollectionListPager",() => new CollectionListPagerDirective());
}
